



















import { Component } from "vue-property-decorator";

import { mixins } from "vue-class-component";
import SharedMixin from "@/mixins/SharedMixin";

import { SectionStore } from "@/feature/Offerte/OfferEvaluation/SectionStore";
import { OtherCostPresaleDetailsCommand } from "@/services/iOrderService";

@Component({})
export default class PgaOfferEvaluationOtherCostsPresaleSubtotals extends mixins( SharedMixin )
{
	get otherCosts() : Array<OtherCostPresaleDetailsCommand>
	{
		return SectionStore.EditOtherCostsPresale.Command.OtherCosts;
	}

	get expectedCost() : number
	{
		if(this.otherCosts.length > 0)
		{
			return this.otherCosts
				.map(oc => oc.ExpectedCost)
				.reduce((sum, current) => sum + current);
		}
		return 0;
	}
}
